import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const Testimonials = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dotsClass: "slick-dots testimonials-dots",
  };

  const testimonials = [
    {
      desc: "I couldn't be happier with my new electric chimney from Alpha Appliances. It's made a huge difference in my kitchen, and the staff were incredibly helpful and friendly throughout the selection and installation process.",
      name: "Ashokbhai Rachhadiya",
      city: "Ahmedabad",
    },
    {
      desc: "I highly recommend Alpha Appliances for anyone in need of a new gas stove. Their prices were competitive, their service was exceptional, and the installation was quick and professional.",
      name: "Pooja Maheta",
      city: "Gandhinagar",
    },
    {
      desc: "Alpha Appliances exceeded my expectations with their wide range of hobs and personalized recommendations. The installation process was seamless, and I'm thrilled with the performance of my new hob.",
      name: "Reshmaben Patel",
      city: "Ahmedabad",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
          What Our Customers Say
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Don't just take our word for it. Here's what our satisfied customers
          have to say about their experience with Alpha Appliances.
        </p>
      </div>

      {/* Testimonials Slider */}
      <div className="mb-16 py-8">
        <Slider {...settings}>
          {testimonials.length > 0 &&
            testimonials.map((value, index) => (
              <div key={index} className="px-8">
                <div className="bg-white rounded-2xl p-8 md:p-12 text-center">
                  <div className="mb-6">
                    <svg
                      className="w-12 h-12 text-orange-400 mx-auto"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                    </svg>
                  </div>
                  <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
                    "{value.desc}"
                  </p>
                  <div className="text-center">
                    <p className="font-semibold text-gray-800 text-lg">
                      {value.name}
                    </p>
                    <p className="text-gray-600 text-sm">{value.city}</p>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 rounded-2xl p-8 md:p-12 text-center text-white">
        <h3 className="text-2xl md:text-3xl font-bold mb-4">
          Ready to Transform Your Kitchen?
        </h3>
        <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto">
          Join thousands of satisfied customers who have upgraded their kitchen
          with Alpha Appliances. Experience the difference today!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={"/contact-us"}
            className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-colors duration-300 transform hover:scale-105"
          >
            Contact Us
          </Link>
          <Link
            to={"/products"}
            className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-indigo-600 font-bold rounded-lg transition-colors duration-300 transform hover:scale-105"
          >
            View Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
